import { render, staticRenderFns } from "./footer-voice-inpout.vue?vue&type=template&id=21c529a3&scoped=true&"
import script from "./footer-voice-inpout.vue?vue&type=script&lang=js&"
export * from "./footer-voice-inpout.vue?vue&type=script&lang=js&"
import style0 from "./footer-voice-inpout.vue?vue&type=style&index=0&id=21c529a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c529a3",
  null
  
)

export default component.exports